export { default as resourcingPlanRoute } from './resourcingPlanRoute';
